// extracted by mini-css-extract-plugin
module.exports = {"howRewardsWorks":"HowRewardsWorks__howRewardsWorks__WRhRu","image":"HowRewardsWorks__image__T-SzD"};